// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconDocument = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M51.4164 32C52.4834 31.9945 53.1789 32.5501 53.2775 33.6126C54.1349 42.8551 55.2226 49.7446 55.9511 53.5332C56.2262 54.9642 55.3042 55.9999 54.1381 55.9999L15.8009 55.9997C14.9879 55.9997 14.3255 55.365 14.1018 54.2422C12.9129 48.2754 10.3867 32.6043 10.0004 10.0362C9.97907 8.78922 10.7547 8.00004 12.0018 8.00004H27.6063C28.5011 8.00004 29.0015 8.59251 29 9.48734C28.9917 14.3526 29.6611 26.125 29.668 26.2398C29.8652 29.6314 32.3623 32 35.7422 32L51.4164 32ZM35.7421 28H51.3876C52.7939 28 53.3662 26.5777 52.3837 25.5953L35.4047 8.49131C34.4221 7.50871 33 8.08134 33 9.48741C33 13.9739 33.5898 24.7807 33.6611 26.0079C33.7352 27.2856 34.5129 28 35.7421 28Z" />
    </svg>
  );
};
